import { logger } from "@scott/logger";
import { createScottApiClient } from "@scott/scott-api";
import { unstable_cache } from "next/cache";
import { cache } from "react";

const getAccessToken = unstable_cache(
  async () => {
    if (!process.env.COMMERCE_CLOUD_CLIENT_ID) {
      throw new Error("COMMERCE_CLOUD_CLIENT_ID is not defined");
    }

    if (!process.env.COMMERCE_CLOUD_CLIENT_SECRET) {
      throw new Error("COMMERCE_CLOUD_CLIENT_SECRET is not defined");
    }

    const client = createScottApiClient();

    const { data, error } = await client.POST("/commerce/v1/bearer-token", {
      body: {
        clientId: process.env.COMMERCE_CLOUD_CLIENT_ID,
        clientSecret: process.env.COMMERCE_CLOUD_CLIENT_SECRET,
      },
    });

    if (error || !data?.data?.access_token) {
      logger.error("getScottApiClient: Login failed", { error });
      throw new Error("Scott API: Failed to obtain access token");
    }

    return data.data.access_token;
  },
  ["scott-b2c-api-access-token"],
  {
    revalidate: 86_400, // cache for 1 day
    tags: [
      "scott-b2c-api-access-token",
      "scott-b2c",
      "scott-b2c-authentication",
    ],
  }
);

export const getScottApiClient = cache(async function getScottApiClient() {
  const token = await getAccessToken();
  return createScottApiClient(token);
});
